import {get, post} from 'external/axios';

export class AuthService {
	 
	async login(data) {
		return post('/auth/login', data);
	}

	async resetPassword(data) {
		return post('/auth/resetPassword', data);
	}

	async changePassword(data) {
		return post('/auth/changePassword', data);
	}

	async getProfileById(clientId) {
		return get(`/client/getprofile/${clientId}`);
	}
}

export const authService = new AuthService();